/**
 * @generated SignedSource<<b965b5751eeb94afe2427a95395ae527>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type ShowMoreFooter_connection$fragmentType: FragmentType;
export type ShowMoreFooter_connection$data = {|
  +pageInfo: ?{|
    +hasNextPage: boolean,
  |},
  +$fragmentType: ShowMoreFooter_connection$fragmentType,
|};
export type ShowMoreFooter_connection$key = {
  +$data?: ShowMoreFooter_connection$data,
  +$fragmentSpreads: ShowMoreFooter_connection$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShowMoreFooter_connection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Connection",
  "abstractKey": "__isConnection"
};

(node/*: any*/).hash = "8023885da685f32c87207a39ff7adf4b";

module.exports = ((node/*: any*/)/*: Fragment<
  ShowMoreFooter_connection$fragmentType,
  ShowMoreFooter_connection$data,
>*/);
